import { doc } from 'firebase/firestore';

import { AccountConfig } from '@superfunnel/types/account-config';

import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const getAccountConfigDocRef = (accountId: string) =>
  doc(db, 'accounts', accountId, 'accountConfig', 'default').withConverter(
    emptyConverter<AccountConfig>(),
  );
